// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm6(){
  var stuwdruk = $('.acf-field').find("[data-name='form6_stuwdruk']").find(':input').val();
  var gewicht = $('.acf-field').find("[data-name='form6_gewicht']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form6_zone']").find('label.selected > input[type="radio"]').val();
  var ankers_hoh = $('.acf-field').find("[data-name='form6_anker_hoh']").find(':input').val();
  var hoogte_element = $('.acf-field').find("[data-name='form6_hoogte']").find(':input').val();
  var houtkwaliteit = $('.acf-field').find("[data-name='form6_kwaliteit']").find('label.selected > input[type="radio"]').val();

  var afstand_a = $('.acf-field').find("[data-name='form6_afstand_a']").find(':input').val();
  var afstand_b = $('.acf-field').find("[data-name='form6_afstand_b']").find(':input').val();
  var lengte_anker = $('.acf-field').find("[data-name='form6_lengte']").find(':input').val();
  var breedte_anker = $('.acf-field').find("[data-name='form6_breedte']").find(':input').val();
  var dikte = $('.acf-field').find("[data-name='form6_dikte']").find(':input').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form6Calculate',
      stuwdruk: stuwdruk,
      gewicht: gewicht,
      zone: zone,
      ankers_hoh: ankers_hoh,
      hoogte_element: hoogte_element,
      houtkwaliteit: houtkwaliteit,
      afstand_a: afstand_a,
      afstand_b: afstand_b,
      lengte_anker: lengte_anker,
      breedte_anker: breedte_anker,
      dikte: dikte
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form6Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });
}

$(document).ready(function(){

  $('#form6Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form6Calc .acf-form-submit').append('<input type="submit" id="calculate_form6" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form6').click(function(e){
    e.preventDefault();
    calculateForm6();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form6.js